module.exports = __webpack_public_path__ + "static/media/ic-infusion-chairs.69c01e99.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ic-infusion-chairs.svg
// module id = 780
// module chunks = 0